import React from 'react';
import { Grid } from '@material-ui/core';

import { FormTextField, FormSelect } from '../../../../components';
import {
  PROXY_APIS_KEY_STATUS_FILTER_BY,
  PROXY_APIS_SORT_BY,
} from '../../../../constants';

export const FilterByName = (props) => (
  <Grid item md={2} sm={2} xs={12}>
    <FormTextField
      {...props}
      id="key-store-filter-by-name"
      data-apim-test="key-store-filter-by-name"
    />
  </Grid>
);

export const FilterByApiKey = (props) => (
  <Grid item md={2} sm={2} xs={12}>
    <FormTextField
      {...props}
      id="key-store-filter-by-api-key"
      data-apim-test="key-store-filter-by-api-key"
    />
  </Grid>
);

export const FilterByKeyStatus = (props) => (
  <Grid item md={2} sm={2} xs={12}>
    <FormSelect
      {...props}
      id="key-store-filter-by-key-status"
      data-apim-test="key-store-filter-by-key-status"
      data={PROXY_APIS_KEY_STATUS_FILTER_BY}
      noNoneOption
      noNativeSelect
    />
  </Grid>
);

export const SortBy = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <FormSelect
      {...props}
      id="key-store-filter-sort-by"
      data-apim-test="key-store-filter-sort-by"
      data={PROXY_APIS_SORT_BY}
      noNoneOption
      noNativeSelect
    />
  </Grid>
);

export const FilterAndSortSeparator = () => (
  <Grid item md={1} />
);

